import React from "react";
import { Formik } from "formik";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";

const AuthForm = ({
  initialValues,
  validationSchema,
  fields,
  onSubmit,
  children,
}) => (
  <Formik
    onSubmit={onSubmit}
    initialValues={initialValues}
    validationSchema={validationSchema}
  >
    {({
      values,
      errors,
      touched,
      handleBlur,
      handleChange,
      handleSubmit,
      setFieldValue,
    }) => (
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
          }}
        >
          {fields.map((field, index) => {
            if (field.type === "select") {
              return (
                <FormControl
                  key={index}
                  fullWidth
                  variant="filled"
                  sx={{ gridColumn: field.gridColumn }}
                  error={!!touched[field.name] && !!errors[field.name]}
                >
                  <InputLabel id={`${field.name}-label`}>
                    {field.label}
                  </InputLabel>
                  <Select
                    labelId={`${field.name}-label`}
                    value={values[field.name]}
                    name={field.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{ textAlign: "start" }}
                  >
                    {field.options.map((option, idx) => (
                      <MenuItem key={idx} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched[field.name] && errors[field.name] && (
                    <Box color="error.main" mt={0.5} textAlign="start">
                      {errors[field.name]}
                    </Box>
                  )}
                </FormControl>
              );
            } else {
              return (
                <TextField
                  key={index}
                  fullWidth
                  variant="filled"
                  type={field.type}
                  label={field.label}
                  onBlur={handleBlur}
                  onChange={(event) =>
                    field.type === "file"
                      ? setFieldValue(field.name, event.currentTarget.files[0])
                      : handleChange(event)
                  }
                  value={field.type === "file" ? undefined : values[field.name]}
                  name={field.name}
                  error={!!touched[field.name] && !!errors[field.name]}
                  helperText={touched[field.name] && errors[field.name]}
                  InputLabelProps={
                    field.type === "file" ? { shrink: true } : undefined
                  }
                  sx={{
                    gridColumn: field.gridColumn,
                    ...(field.type === "file"
                      ? { "& .MuiInputBase-input": { mb: "10px" } }
                      : {}),
                  }}
                />
              );
            }
          })}
        </Box>
        {children}
      </form>
    )}
  </Formik>
);

export default AuthForm;
